import { Link } from "@fullscript/aviary-web";
import { faChevronLeft } from "@fullscript/pro-solid-svg-icons";

import type { AviaryLinkProps } from "@aviary/components/Link/Link";
import { FullstorySafeToCapture } from "@shared/components/Fullstory/FullstorySafeToCapture";
import { FontAwesomeIcon } from "@shared/react-fontawesome/react-fontawesome";
import { useNavigate } from "@shared/react-router-dom/react-router-dom";

import * as styles from "./BackButton.styles";

interface Props extends Pick<AviaryLinkProps, "to" | "onClick" | "isUnderLined" | "state"> {
  /*
   * To be used as link text
   */
  text: string;
  /*
   * To be used as link text
   */
  isMarginless?: boolean;
}

const BackButton = ({
  isMarginless = false,
  text,
  to,
  onClick,
  isUnderLined = true,
  ...rest
}: Props) => {
  const navigate = useNavigate();

  const linkStyles = [styles.backButton, !isMarginless && styles.margin];

  const handleBack = () => {
    if (to) return null;

    return navigate(-1);
  };

  return (
    <div css={styles.backButtonContainer}>
      <Link
        customCss={linkStyles}
        onClick={onClick ? onClick : handleBack}
        to={to}
        hideUnderline={!isUnderLined}
        {...rest}
      >
        <FontAwesomeIcon css={styles.chevron} icon={faChevronLeft} aria-hidden />
        <FullstorySafeToCapture as="span">{text}</FullstorySafeToCapture>
      </Link>
    </div>
  );
};

export { BackButton };
export type { Props as BackButtonProps };
